import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Breadcrumb, Tabs } from "antd";
import { Link } from "react-router-dom";
import SubscribedNewsletter from "./SubscribedNewsletter";
import UnsubscribedNewsletter from "./UnsubscribedNewsletter";

const Newsletter = () => {
  const { t } = useTranslation();

  const onChange = (key) => {
  };
  const items = [
    {
      key: "1",
      label: <Trans> Subscribe</Trans>,
      children: <SubscribedNewsletter />,
    },
    {
      key: "2",
      label: <Trans> Un Subscribe</Trans>,
      children: <UnsubscribedNewsletter />,
    },
  ];

  return (
    <>
      <div className="contentpart">
        <div className="right_content_col">
          <div className="content_wraper ">
            <div className="myorder">
              <div className="pagename">
                Newsletter
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to="/dashboard">{t("home")}</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>Newsletter</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <br />

              <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
